import { TemplateParmDTO, TemplateValidacaoParmDTO } from '@/interfaces/prescription-template';
import { apiClient } from '@/services/api';
import { ENDPOINTS } from '@/settings/api-settings';
import { from, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export function getPrescriptionTemplates(): Observable<any[]> {
  return from(apiClient.get(`${ENDPOINTS.TEMPLATE}`)).pipe(
    map((r: any) => r.data),
  );
}

export function getPrescriptionTemplatesCombo(idClientUnit: number, patientType: string): Observable<any[]> {
    return from(apiClient.get(`${ENDPOINTS.TEMPLATE_COMBOBOX}`, {idUnidadeCliente: idClientUnit, tipoPaciente: patientType})).pipe(
      map((r: any) => r.data),
    );
}

export function getTemplatePreview(idTemplate: number): Observable<any> {
    return from(apiClient.get(ENDPOINTS.TEMPLATE_PREVIEW.replaceAll("{id}", idTemplate.toString()))).pipe(
      map((r: any) => r.data),
    );
}

export function getMultiCompTemplateOptions(): Observable<any[]> {
  return from(apiClient.get(`${ENDPOINTS.TEMPLATE_MULTICOMP_OPTIONS}`)).pipe(
    map((r: any) => r.data),
  );
}

export function getPrescriptionTemplate(id: string): Observable<any> {
  return from(apiClient.get(`${ENDPOINTS.TEMPLATE}/${id}`)).pipe(
    map((r: any) => r.data),
  );
}

export function validatePrescriptionTemplate(payload: TemplateValidacaoParmDTO): Observable<any> {
  return from(apiClient.post(ENDPOINTS.TEMPLATE_VALIDATION, payload)).pipe(
    map((r: any) => r.data),
  );
}

export function savePrescriptionTemplate(payload: TemplateParmDTO): Observable<any> {
  if (payload.id) {
    return from(apiClient.put(ENDPOINTS.TEMPLATE, payload)).pipe(
      map((r: any) => r.data),
    );
  }
  return from(apiClient.post(ENDPOINTS.TEMPLATE, payload)).pipe(
    map((r: any) => r.data),
  );
}

export function activateTemplate(idTemplate: Number, ativo: boolean): Observable<any> {
  return from(apiClient.put(`${ENDPOINTS.TEMPLATE}/${idTemplate}/ativacao?ativo=${ativo}`, null)).pipe(
    map((r: any) => r.data),
  );
}

export function deletePrescriptionTemplate(id: string): Observable<any> {
  return from(
    apiClient.delete(`${ENDPOINTS.TEMPLATE}/${id}`),
  ).pipe(map((r: any) => (!!r.data ? r.data : [])));
}

export function recalcPatternValues(idTemplate:number, volume: number): Observable<any> {
  return from(
    apiClient.get(ENDPOINTS.TEMPLATE_RECALC, {idTemplate, volume}),
  ).pipe(map((r: any) => r.data));
}
